import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {prepareSameWindowUrlWithNavigateTo} from 'app/utilities/StringHelpers/StringHelpers';
import Config from 'app/Config';

const SelfCareItem = ({context, headerData, item, i}) => {
  const isLastItem = i === headerData?.selfCareData?.regularButtons?.expandedValue?.length - 1;
  const className = `${isLastItem ? 'last' : ''} item-regular`;

  return (
    <div key={i} onClick={() => prepareSameWindowUrlWithNavigateTo(item?.link?.value, context)} className={className}>
      {item?.menuImage?.value != null && <Image src={Config.epiBaseUrl + item?.menuImage?.expandedValue?.url} />}
      <div>{item?.text?.value}</div>
      <div className='img-arrow'>
        <Image src={require('../../images/left.svg')} />
      </div>
    </div>
  );
};

export default SelfCareItem;
